import { useSupportDrawerContext } from 'src/components/support-drawer';

export function useHeaderWidth(): string {
  const drawerContext = useSupportDrawerContext();

  let headerWidth: string = '100%';
  if (drawerContext.openDrawer) {
    if (drawerContext.drawerWidth.includes('%')) {
      const numPart: string = drawerContext.drawerWidth.replace('%', '');
      const calcDrawer: number = Number.parseFloat(numPart) / 100;
      headerWidth = `calc(100% - (100vw * ${calcDrawer.toString()}))`;
    } else {
      headerWidth = `calc(100% - ${drawerContext.drawerWidth})`;
    }
  }

  return headerWidth;
}
